// extracted by mini-css-extract-plugin
export default {"root":"Header_root__3whXf","title":"Header_title__cPueh"};